<div
  [class.is-invalid-wrapper]="isFieldInvalid()"
  [class.disabled-control-wrapper]="isDisabled()"
  *ngIf="!fieldAttribute.hidden"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
  class="multiple-select-container"
>
  <label
    *ngIf="fieldAttribute.backendAttribute.label"
    [for]="fieldAttribute.id"
    class="form-label label"
    [ngClass]="fieldAttribute.elementStyles.labelStyle"
    (click)="$event.preventDefault()"
  >
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
    <div
      *ngIf="isShowInfoTooltip && tooltipDescription"
      class="ms-1 custom-tooltip"
      data-test-id="info-tooltip-disease"
      placement="bottom auto"
      triggers="click:blur"
      [ngbTooltip]="tipContent"
    >
      <img src="assets/icons/icon-info.svg" alt="info" />
    </div>
  </label>

  <dx-drop-down-box
    [disabled]="isDisabled()"
    [attr.data-test-id]="fieldAttribute.elementDataTestId"
    [value]="selectedItemText"
    [dataSource]="selectedItemText"
    [placeholder]="(isMobileView ? newPlaceholder : fieldAttribute.backendAttribute.placeholder) | translate"
    [showClearButton]="true"
    (onOpened)="onOpened()"
    (onValueChanged)="onDropDownBoxValueChanged($event)"
    (onClosed)="onBlur()"
  >
    <div *dxTemplate="let data of 'content'">
      <dx-text-box
        [value]="searchValue"
        (onInput)="onSearchValueChanged($event)"
        [placeholder]="'Search...'"
        class="mb-2"
      >
      </dx-text-box>

      <dx-tree-view
        [dataSource]="filteredTreeData"
        dataStructure="tree"
        selectionMode="multiple"
        showCheckBoxesMode="normal"
        [selectByClick]="true"
        [selectNodesRecursive]="false"
        (onContentReady)="updateSelection()"
        (onItemSelectionChanged)="onItemSelectionChanged($event)"
        noDataText=""
      >
      </dx-tree-view>
    </div>
  </dx-drop-down-box>

  <div
    [attr.data-test-id]="fieldAttribute.errorDataTestId"
    *ngIf="control && control.errors && control.touched"
    class="invalid-feedback d-block"
  >
    {{ 'FIELD_REQUIRED_ERROR' | translate }}
  </div>
</div>

<ng-template #tipContent
  >{{ tooltipDescription }}
  <a class="contact-us text-primary" data-test-id="login-form-forgot-password" [routerLink]="'/contact-us'">
    {{ 'FOOTER_NAVIGATION_CONTACT_US' | translate }} </a
  >.</ng-template
>
